"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _variable = _interopRequireDefault(require("./variable"));
var _GEHelper = require("../../graphicEngine/GEHelper");
var _GEDragHelper = require("../../graphicEngine/GEDragHelper");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0, _get2["default"])((0, _getPrototypeOf2["default"])(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
var ListVariable = /*#__PURE__*/function (_Variable) {
  function ListVariable(variable) {
    var _this;
    (0, _classCallCheck2["default"])(this, ListVariable);
    Entry.assert(variable.variableType === 'list', 'Invalid variable type given');
    _this = _callSuper(this, ListVariable, [variable]);
    _this.array_ = variable.array ? variable.array : [];
    if (!variable.isClone) {
      _this.width_ = variable.width ? variable.width : 100;
      _this.height_ = variable.height ? variable.height : 120;
      _this.scrollPosition = 0;
    }
    return _this;
  }
  (0, _inherits2["default"])(ListVariable, _Variable);
  return (0, _createClass2["default"])(ListVariable, [{
    key: "LIST_MAX_LENGTH",
    get: function get() {
      return 5000;
    }
  }, {
    key: "generateView",
    value: function generateView(variableIndex) {
      this.view_ = _GEHelper.GEHelper.newContainer();
      this.rect_ = _GEHelper.GEHelper.newGraphic();
      this.view_.addChild(this.rect_);
      this.view_.variable = this;
      this.view_.visible = this.visible_;
      this.view_.mouseEnabled = true;
      this.view_.mouseChildren = true;
      _GEDragHelper.GEDragHelper.handleDrag(this.view_);
      this.titleView_ = _GEHelper.GEHelper.textHelper.newText('', this.FONT, '#000000', 'alphabetic', 'center');

      //todo [박봉배] textview_.width 를 $width 로 변경.
      this.titleView_.$width = this.width_ - 2 * this.BORDER;
      if (_GEHelper.GEHelper.isWebGL) {
        this.titleView_.x = (this.width_ - this.titleView_.width) / 2;
        this.titleView_.y = this.BORDER - 1;
      } else {
        this.titleView_.x = this.width_ / 2;
        this.titleView_.y = this.BORDER + 11;
      }
      this.view_.addChild(this.titleView_);
      var _ref = EntryStatic.images || {},
        stage_list_resize_handle = _ref.stage_list_resize_handle;
      this.resizeHandle_ = _GEHelper.GEHelper.newSpriteWithCallback(stage_list_resize_handle || "".concat(Entry.mediaFilePath, "stage_list_resize_handle.png"), function () {
        Entry.requestUpdate = true;
      });
      this.resizeHandle_.mouseEnabled = true;
      this.resizeHandle_.scaleX = 0.7;
      this.resizeHandle_.scaleY = 0.7;
      this.view_.addChild(this.resizeHandle_);
      this.resizeHandle_.list = this;
      _GEDragHelper.GEDragHelper.handleDrag(this.resizeHandle_);
      this.resizeHandle_.on(_GEDragHelper.GEDragHelper.types.OVER, function () {
        this.cursor = 'nwse-resize';
      });
      this.resizeHandle_.on(_GEDragHelper.GEDragHelper.types.DOWN, function (evt) {
        // if(Entry.type != 'workspace') return;
        this.list.isResizing = true;
        this.offset = {
          x: evt.stageX * 0.75 - this.list.getWidth(),
          y: evt.stageY * 0.75 - this.list.getHeight()
        };
        this.parent.cursor = 'nwse-resize';
      });
      this.resizeHandle_.on(_GEDragHelper.GEDragHelper.types.MOVE, function (evt) {
        // if(Entry.type != 'workspace') return;
        this.list.setWidth(evt.stageX * 0.75 - this.offset.x);
        this.list.setHeight(evt.stageY * 0.75 - this.offset.y);
        this.list.updateView();
      });
      this.view_.on(_GEDragHelper.GEDragHelper.types.OVER, function () {
        this.cursor = 'move';
      });
      this.view_.on(_GEDragHelper.GEDragHelper.types.DOWN, function (evt) {
        if (Entry.type !== 'workspace' || this.variable.isResizing) {
          return;
        }
        this.offset = {
          x: this.x - (evt.stageX * 0.75 - 240),
          y: this.y - (evt.stageY * 0.75 - 135)
        };
        this.cursor = 'move';
      });
      this.view_.on(_GEDragHelper.GEDragHelper.types.UP, function () {
        this.cursor = 'initial';
        this.variable.isResizing = false;
      });
      this.view_.on(_GEDragHelper.GEDragHelper.types.MOVE, function (evt) {
        if (Entry.type !== 'workspace' || this.variable.isResizing) {
          return;
        }
        this.variable.setX(evt.stageX * 0.75 - 240 + this.offset.x);
        this.variable.setY(evt.stageY * 0.75 - 135 + this.offset.y);
        this.variable.updateView();
      });

      //todo [박봉배] 아래줄 삭제 하는게 맞겠죠? 리스트 아이템인데, 생성을 아래쪽에서 함.
      //this.elementView = this._createListElementView();
      this.scrollButton_ = _GEHelper.GEHelper.newGraphic();
      this.scrollButton_.mouseEnabled = true;
      this.scrollButton_.cursor = 'pointer';
      _GEDragHelper.GEDragHelper.handleDrag(this.scrollButton_);
      this.scrollButton_.graphics.f('#aaaaaa').rr(0, 0, 7, 30, 3.5);
      this.view_.addChild(this.scrollButton_);
      this.scrollButton_.y = 25;
      this.scrollButton_.list = this;
      this.scrollButton_.on(_GEDragHelper.GEDragHelper.types.DOWN, function (evt) {
        // if(Entry.type != 'workspace') return;
        this.list.isResizing = true;
        this.offsetY = evt.stageY - this.y / 0.75;
      });
      this.scrollButton_.on(_GEDragHelper.GEDragHelper.types.MOVE, function (evt) {
        // if(Entry.type != 'workspace') return;

        var stageY = evt.stageY;
        var yPos = (stageY - this.offsetY) * 0.75;
        var min = 25;
        var max = this.list.getHeight() - 30;
        if (yPos < min) {
          yPos = min;
        }
        if (yPos > max) {
          yPos = max;
        }
        this.y = yPos;
        this.list.updateView();
      });
      if (this.getX() && this.getY()) {
        this.setX(this.getX());
        this.setY(this.getY());
      } else {
        var listLength = Entry.variableContainer.lists_.length;
        this.setX(-Math.floor(listLength % 24 / 6) * 110 + 120);
        this.setY(variableIndex * 24 + 20 - 135 - Math.floor(listLength / 6) * 145);
      }
      this.setVisible(this.isVisible());
      Entry.stage.loadVariable(this);
    }
  }, {
    key: "getArray",
    value: function getArray() {
      if (!this.isRealTime_) {
        return this.array_;
      } else {
        var _ref2 = this.cloudVariable.get({
            variableType: this.type,
            id: this.id_
          }) || {},
          array = _ref2.array;
        return array || this.array_;
      }
    }
  }, {
    key: "setArray",
    value: function setArray(array) {
      var _this2 = this;
      if (!this.isRealTime_) {
        this.array_ = array;
        this.updateView();
        Entry.requestUpdateTwice = true;
      } else {
        return new Promise(/*#__PURE__*/function () {
          var _ref3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(resolve, reject) {
            var target, _t;
            return _regenerator["default"].wrap(function (_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  target = {
                    variableType: _this2.type,
                    id: _this2.id_
                  };
                  _context.next = 1;
                  return _this2.cloudVariable.setArray(target, array);
                case 1:
                  _this2.updateView();
                  resolve();
                  _context.next = 3;
                  break;
                case 2:
                  _context.prev = 2;
                  _t = _context["catch"](0);
                  reject(_t);
                case 3:
                case "end":
                  return _context.stop();
              }
            }, _callee, null, [[0, 2]]);
          }));
          return function (_x, _x2) {
            return _ref3.apply(this, arguments);
          };
        }());
      }
    }
  }, {
    key: "appendValue",
    value: function appendValue(value) {
      var _this3 = this;
      if (!this.isRealTime_) {
        if (!this.array_) {
          this.array_ = [];
        }
        this.array_.push({
          data: value
        });
        this.updateView();
      } else {
        return new Promise(/*#__PURE__*/function () {
          var _ref4 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(resolve, reject) {
            var target, list, _t2;
            return _regenerator["default"].wrap(function (_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.prev = 0;
                  target = {
                    variableType: _this3.type,
                    id: _this3.id_
                  };
                  _context2.next = 1;
                  return _this3.cloudVariable.append(target, value);
                case 1:
                  list = _this3.cloudVariable.get(target);
                  if (list) {
                    _this3.array_ = list.array;
                  } else {
                    _this3.array_.push({
                      data: value
                    });
                  }
                  _this3.updateView();
                  resolve();
                  _context2.next = 3;
                  break;
                case 2:
                  _context2.prev = 2;
                  _t2 = _context2["catch"](0);
                  reject(_t2);
                case 3:
                case "end":
                  return _context2.stop();
              }
            }, _callee2, null, [[0, 2]]);
          }));
          return function (_x3, _x4) {
            return _ref4.apply(this, arguments);
          };
        }());
      }
    }
  }, {
    key: "deleteValue",
    value: function deleteValue(index) {
      var _this4 = this;
      if (!this.isRealTime_) {
        this.array_.splice(index - 1, 1);
        this.updateView();
      } else {
        return new Promise(/*#__PURE__*/function () {
          var _ref5 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(resolve, reject) {
            var target, list, _t3;
            return _regenerator["default"].wrap(function (_context3) {
              while (1) switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.prev = 0;
                  target = {
                    variableType: _this4.type,
                    id: _this4.id_
                  };
                  _context3.next = 1;
                  return _this4.cloudVariable["delete"](target, index - 1);
                case 1:
                  list = _this4.cloudVariable.get(target);
                  if (list) {
                    _this4.array_ = list.array;
                  } else {
                    _this4.array_.splice(index - 1, 1);
                  }
                  _this4.updateView();
                  resolve();
                  _context3.next = 3;
                  break;
                case 2:
                  _context3.prev = 2;
                  _t3 = _context3["catch"](0);
                  reject(_t3);
                case 3:
                case "end":
                  return _context3.stop();
              }
            }, _callee3, null, [[0, 2]]);
          }));
          return function (_x5, _x6) {
            return _ref5.apply(this, arguments);
          };
        }());
      }
    }
  }, {
    key: "insertValue",
    value: function insertValue(index, data) {
      var _this5 = this;
      if (!this.isRealTime_) {
        this.array_.splice(index - 1, 0, {
          data: data
        });
        this.updateView();
      } else {
        return new Promise(/*#__PURE__*/function () {
          var _ref6 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(resolve, reject) {
            var target, list, _t4;
            return _regenerator["default"].wrap(function (_context4) {
              while (1) switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.prev = 0;
                  target = {
                    variableType: _this5.type,
                    id: _this5.id_
                  };
                  _context4.next = 1;
                  return _this5.cloudVariable.insert(target, index - 1, data);
                case 1:
                  list = _this5.cloudVariable.get(target);
                  if (list) {
                    _this5.array_ = list.array;
                  } else {
                    _this5.array_.splice(index - 1, 0, {
                      data: data
                    });
                  }
                  _this5.updateView();
                  resolve();
                  _context4.next = 3;
                  break;
                case 2:
                  _context4.prev = 2;
                  _t4 = _context4["catch"](0);
                  reject(_t4);
                case 3:
                case "end":
                  return _context4.stop();
              }
            }, _callee4, null, [[0, 2]]);
          }));
          return function (_x7, _x8) {
            return _ref6.apply(this, arguments);
          };
        }());
      }
    }
  }, {
    key: "replaceValue",
    value: function replaceValue(index, data) {
      var _this6 = this;
      if (!this.isRealTime_) {
        this.array_[index - 1].data = data;
        this.updateView();
      } else {
        return new Promise(/*#__PURE__*/function () {
          var _ref7 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(resolve, reject) {
            var target, list, _t5;
            return _regenerator["default"].wrap(function (_context5) {
              while (1) switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.prev = 0;
                  target = {
                    variableType: _this6.type,
                    id: _this6.id_
                  };
                  _context5.next = 1;
                  return _this6.cloudVariable.replace(target, index - 1, data);
                case 1:
                  list = _this6.cloudVariable.get(target);
                  if (list) {
                    _this6.array_ = list.array;
                  } else {
                    _this6.array_[index - 1].data = data;
                  }
                  _this6.updateView();
                  resolve();
                  _context5.next = 3;
                  break;
                case 2:
                  _context5.prev = 2;
                  _t5 = _context5["catch"](0);
                  reject(_t5);
                case 3:
                case "end":
                  return _context5.stop();
              }
            }, _callee5, null, [[0, 2]]);
          }));
          return function (_x9, _x0) {
            return _ref7.apply(this, arguments);
          };
        }());
      }
    }
  }, {
    key: "updateView",
    value: function updateView() {
      if (!this.view_) {
        return;
      }
      if (this.isVisible()) {
        this._adjustSingleViewPosition();
        this.resizeHandle_.x = this.width_ - 10;
        this.resizeHandle_.y = this.height_ + 16 - 10;
        var arr = this.getArray();
        var name = this.getName();
        if (this.object_) {
          var obj = Entry.container.getObject(this.object_);
          if (obj) {
            name = "".concat(obj.name, ":").concat(name);
          }
        }
        this.titleView_.text = name;
        if (this.titleView_.getMeasuredWidth() > this.width_) {
          name = "".concat(name, "..");
          while (this.titleView_.getMeasuredWidth() > this.width_) {
            name = "".concat(name.substr(0, name.length - 3), "..");
            this.titleView_.text = name;
          }
        }
        if (_GEHelper.GEHelper.isWebGL) {
          this.titleView_.x = (this.width_ - this.titleView_.width) / 2 + 3;
        } else {
          this.titleView_.x = this.width_ / 2 + 3;
        }
        var colorSet = EntryStatic.colorSet.canvas || {};
        this.rect_.graphics.clear().f('#ffffff').ss(1, 2, 0).s(colorSet.border || '#aac5d5').rr(0, 0, this.width_ + 7, this.height_ + 22, this.RECT_RADIUS);
        var listChild;
        while (listChild = this.view_.children[4]) {
          this.view_.removeChild(listChild);
          listChild.destroy && listChild.destroy();
        }
        var maxView = Math.floor((this.getHeight() - 15) / 20);
        var isOverFlow = maxView < arr.length;
        var totalWidth = this.getWidth();
        var wrapperWidth = totalWidth - 2 * this.BORDER - (isOverFlow ? 30 : 20);
        if (isOverFlow) {
          if (this.scrollButton_.y > this.getHeight() - 30) {
            this.scrollButton_.y = this.getHeight() - 30;
          }
          //todo [박봉배] _createListElementView 로 코드 이동
          // this.elementView.valueWrapper.graphics
          //     .clear()
          //     .f('#1bafea')
          //     .rr(20, -2, wrapperWidth, 17, 2);
          this.scrollButton_.x = totalWidth - 6;
          this.scrollPosition = Math.floor((this.scrollButton_.y - 25) / (this.getHeight() - 25 - 30) * (arr.length - maxView));
        } else {
          //todo [박봉배] _createListElementView 로 코드 이동
          // this.elementView.valueWrapper.graphics
          //     .clear()
          //     .f('#1bafea')
          //     .rr(20, -2, wrapperWidth, 17, 2);
          this.scrollPosition = 0;
        }
        this.scrollButton_.visible = isOverFlow;
        var _cache = {};
        //because of min Width of list
        //maxLen can not be under 3
        //so start from 3
        var maxLen = 3;
        wrapperWidth -= 6;
        for (var i = this.scrollPosition; i < this.scrollPosition + maxView && i < arr.length; i++) {
          var _arr$i$data, _arr$i;
          this.elementView = this._createListElementView(wrapperWidth + 14);
          if (Entry.getMainWS() && Entry.getMainWS().getMode() === Entry.Workspace.MODE_VIMBOARD) {
            this.elementView.indexView.text = i;
          } else {
            this.elementView.indexView.text = i + 1;
          }
          var text = String((_arr$i$data = arr === null || arr === void 0 || (_arr$i = arr[i]) === null || _arr$i === void 0 ? void 0 : _arr$i.data) !== null && _arr$i$data !== void 0 ? _arr$i$data : 'undefined');
          var valueView = this.elementView.valueView;
          var cachedText = _cache[text.substr(0, 150)];
          if (cachedText) {
            valueView.text = cachedText;
          } else {
            var execText = text.substr(0, maxLen);
            var charIndex = maxLen;
            valueView.text = text;
            if (valueView.getMeasuredWidth() > wrapperWidth) {
              valueView.text = execText;
              while (valueView.getMeasuredWidth() < wrapperWidth && text[charIndex] !== undefined) {
                execText += text[charIndex++];
                valueView.text = execText;
              }
              var subCnt = 1;
              while (valueView.getMeasuredWidth() > wrapperWidth) {
                execText = "".concat(execText.substr(0, execText.length - subCnt), "..");
                valueView.text = execText;
                subCnt = 3;
              }
            } else {
              execText = text;
            }
            _cache[text.substr(0, 150)] = execText;
            maxLen = Math.max(execText.length, maxLen);
          }
          this.elementView.y = (i - this.scrollPosition) * 20 + 23;
          this.view_.addChild(this.elementView);
        }
      }
      Entry.requestUpdate = true;
    }
  }, {
    key: "_createListElementView",
    value: function _createListElementView(wrapperWidth) {
      var elementView = _GEHelper.GEHelper.newContainer();
      var indexView = _GEHelper.GEHelper.textHelper.newText('', this.FONT, '#000000', 'middle');
      var colorSet = EntryStatic.colorSet.canvas || {};
      if (_GEHelper.GEHelper.isWebGL) {
        indexView.y = this.GL_LIST_POS.INDEX_Y;
      } else {
        indexView.y = 12;
      }
      elementView.addChild(indexView);
      elementView.indexView = indexView;
      var valueWrapper = _GEHelper.GEHelper.newGraphic();
      elementView.addChild(valueWrapper);
      elementView.valueWrapper = valueWrapper;
      elementView.valueWrapper.graphics.clear().f(colorSet.list || '#4f80ff').rr(18, 4, wrapperWidth, 17, 2);
      var valueView = _GEHelper.GEHelper.textHelper.newText('', this.VALUE_FONT, '#ffffff', 'middle');
      valueView.x = 24;
      if (_GEHelper.GEHelper.isWebGL) {
        valueView.y = this.GL_LIST_POS.VALUE_Y;
      } else {
        valueView.y = 12;
      }
      elementView.addChild(valueView);
      elementView.valueView = valueView;
      elementView.x = this.BORDER;
      return elementView;
    }
  }, {
    key: "syncModel_",
    value: function syncModel_(variableModel) {
      if (!this.isCloud_ && !this.isRealTime_) {
        this.array_ = variableModel.array;
      }
      this.setWidth(variableModel.width);
      this.setHeight(variableModel.height);
      _superPropGet(ListVariable, "syncModel_", this, 3)([variableModel]);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var json = _superPropGet(ListVariable, "toJSON", this, 3)([]);
      json.width = this.getWidth();
      json.height = this.getHeight();
      json.array = JSON.parse(JSON.stringify(this.getArray()));
      return json;
    }
  }]);
}(_variable["default"]);
var _default = exports["default"] = ListVariable;